import { render } from "./ModelComponent.vue?vue&type=template&id=65d2b33d"
import script from "./ModelComponent.vue?vue&type=script&lang=js"
export * from "./ModelComponent.vue?vue&type=script&lang=js"

import "./ModelComponent.vue?vue&type=style&index=0&id=65d2b33d&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__